import React, { useEffect, useRef, useState } from "react"
import style from "./rangeDropdown.module.scss"
import numberWithCommas from '../../../helpers/actions/numberWithCommas'
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

const RangeDropdown = (props) => {

    const wrapperRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false)
    const [rangeValue, setRangeValue] = useState({ min: 0, max: 0 })
    const [range, setRange] = useState({ min: 0, max: 0 })
    const [clicked, setClicked] = useState(false)
    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };

    }, []);

    useEffect(() => {
        if (!showDropdown) {
            props.action(true)
        }
    }, [showDropdown])
    useEffect(() => {
        if (typeof props.value !== "undefined" && typeof props.defaultRange !== "undefined" && props.value.from && props.value.to &&
            (props.value.from != rangeValue.min || props.value.to != rangeValue.max)) {
            let rangeVal = rangeValue
            rangeVal.min = props.value.from
            rangeVal.max = props.value.to
            setRangeValue({ ...rangeVal })
            setClicked(true)
        }
    }, [props.value])
    useEffect(() => {
        if (props.setToDefault && typeof props.defaultRange !== "undefined") {
            deleteAll()
        }
    }, [props.setToDefault])

    useEffect(() => {
        if (typeof props.defaultRange !== "undefined" && props.defaultRange.from && props.defaultRange.to
        ) {
            let rangeVal = rangeValue
            if (rangeVal.min) {
                rangeVal.min = props.defaultRange.from
            }
            if (rangeVal.max) {
                rangeVal.max = props.defaultRange.to
            }
            setRangeValue({ ...rangeVal })
        }
    }, [props.defaultRange])


    //   const getRange = async() =>{
    //     let res= await GetReportFilterRange({field:props.tag})
    //     if(typeof res !=="undefined" && res.data.success){
    //       let Range=range
    //       Range.min= res.data.min
    //       Range.max=res.data.max
    //       setRange({...Range})
    //       setRangeValue({...Range})
    //     }
    // }

    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            // props.setData(props.tag,addItemAction())
            setShowDropdown(false)
        }
    };
    const toggleShow = () => {
        setShowDropdown(!showDropdown);
    }
    const submitChanges = () => {
        setClicked(true)
        props.setData(props.tag, addItemAction())
        toggleShow()

    }
    const handleChange = (value) => {
        let rangeVal = rangeValue;
        if (value[0] !== range.min && value[1] !== range.max || value[0] !== value[1]) {
            rangeVal.min = value[0]
            rangeVal.max = value[1]
            setRangeValue({ ...rangeVal })
        }

    }
    const handleInputs = (e, type) => {
        let rangeVal = rangeValue
        let result = toEnglishNumber(String(e.target.value).replaceAll(',', ''))
        if (type === 'max') {
            rangeVal[type] = result <= props.defaultRange.to ? result : props.defaultRange.to
            setRangeValue({ ...rangeVal })
        } else if (type === 'min') {
            rangeVal[type] = result >= props.defaultRange.from ? result : props.defaultRange.from
            setRangeValue({ ...rangeVal })
        }

    }
    const deleteAll = () => {
        let rangeVal = rangeValue
        rangeVal.min = props.defaultRange.from
        rangeVal.max = props.defaultRange.to
        setRangeValue({ ...rangeVal })
        setClicked(false)
        props.setData(props.tag, addItemAction())


    }

    const addItemAction = () => {
        let obj = {}
        obj["from"] = parseInt(rangeValue.min);
        obj["to"] = parseInt(rangeValue.max);
        return obj
    }

    return (
        <React.Fragment>
            <div className={style.dropdownWrapper} ref={wrapperRef}>

                <button
                    onClick={toggleShow}
                    className={clicked && !props.setToDefault ? style.dropdownButtonSelected : style.dropdownButton}
                    type="button">
                    {clicked && !props.setToDefault ? <span>f</ span> : null}
                    {props.placeHolder ? props.placeHolder : 'انتخاب'}
                </button>

                <div className={showDropdown ? style.dropdownContent : style.dropdownContentHide}>

                    <div className={showDropdown ? style.contentDiv : style.contentHideDiv}>
                        <div className={style.rangeSliderWrapper}>
                            {/* <input className={style.left} type="range" min={props.min.toString()} max={props.max.toString()} value={rangeValue.min} onChange={e => handleChange(e, "min")} />
              <div className={style.bar}><div className={style.barFiller} style={{ width: "50%" , left:rangeValue.min+"%"}}></div></div>
              <input className={style.right} type="range" min={props.min.toString()} max={props.max.toString()} value={rangeValue.max} onChange={e => handleChange(e, "max")} /> */}
                            <Range
                                value={typeof props.defaultRange !== "undefined" && (rangeValue.min == 0 && rangeValue.max == 0) ?
                                    [props.defaultRange.from, props.defaultRange.to] : [rangeValue.min, rangeValue.max]}
                                defaultValue={[props.min, props.max]}
                                min={typeof props.defaultRange !== "undefined" && props.defaultRange.from}
                                max={typeof props.defaultRange !== "undefined" && props.defaultRange.to}
                                step={1}
                                onChange={handleChange}
                                trackStyle={[{
                                    backgroundColor: props.defaultRange.from === props.defaultRange.to ? "#d0d3dc" : "#192a56",
                                    height: "4px"
                                }]}
                                handleStyle={[{
                                    width: "12px",
                                    height: "12px",
                                    marginTop: "-4px",
                                    boxShadow: "none",
                                    border: "none",
                                    backgroundColor: props.defaultRange.from === props.defaultRange.to ? "#d0d3dc" : "#192a56"
                                },
                                {
                                    width: "12px",
                                    height: "12px",
                                    marginTop: "-4px",
                                    boxShadow: "none",
                                    border: "none",
                                    backgroundColor: props.defaultRange.from === props.defaultRange.to ? "#d0d3dc" : "#192a56"
                                }]} />
                            <div className={style.inputsWrapper}>
                                <div className={style.container}>
                                    <input
                                        disabled={props.defaultRange.from === props.defaultRange.to}
                                        style={{ width: (typeof props.defaultRange !== "undefined" && props.defaultRange.to.toString().length + 1) * 8 + 26 + "px" }}
                                        type="text"
                                        value={typeof props.defaultRange !== "undefined" && rangeValue.min == 0 && props.defaultRange.from ? toPersianNumber(numberWithCommas(props.defaultRange.from)) : toPersianNumber(numberWithCommas(rangeValue.min))}
                                        onChange={e => handleInputs(e, "min")} />
                                    <span
                                        className={props.defaultRange.from === props.defaultRange.to && style.disabledText}>{props.unitLabel}</span>
                                </div>
                                <div className={style.container}>
                                    <input
                                        disabled={props.defaultRange.from === props.defaultRange.to}
                                        style={{ width: (typeof props.defaultRange !== "undefined" && props.defaultRange.to.toString().length + 1) * 8 + 26 + "px" }}
                                        type="text"
                                        value={typeof props.defaultRange !== "undefined" && rangeValue.max == 0 ? toPersianNumber(numberWithCommas(props.defaultRange.to)) : toPersianNumber(numberWithCommas(rangeValue.max))}
                                        onChange={e => handleInputs(e, "max")} />
                                    <span
                                        className={props.defaultRange.from === props.defaultRange.to && style.disabledText}>{props.unitLabel}</span>
                                </div>
                            </div>
                        </div>
                        {
                            props.defaultRange.from === props.defaultRange.to ?
                                <div className={style.warningWrapper}>
                                    <div className={style.icon}>h</div>
                                    <div className={style.text}>
                                        تنها مقدار موجود برای این متغیر
                                        {" " + toPersianNumber(props.defaultRange.from) + " "}{props.unitLabel + " "}
                                        است
                                    </div>
                                </div>
                                :
                                <div className={style.warningWrapperEmpty}></div>
                        }
                    </div>

                    <div className={showDropdown ? style.dropdownActionsWrapper : style.dropdownActionsWrapperHide}>
                        <button onClick={submitChanges} className={style.addItemAction}
                            disabled={props.defaultRange.from === props.defaultRange.to}>اعمال
                        </button>
                        {<button onClick={deleteAll} className={style.deleteItemAction}
                            disabled={props.defaultRange.from === props.defaultRange.to}>پاک‌کردن</button>}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default RangeDropdown;

/*
*
tag='برند'                               :The tag that will be returned everytime a function inside the component is called(REQUIRED)
label='برند'                             :Label is the text above dropdown and its OPTIONAL
placeHolder='برند'               :Placeholder is the text inside dropdown button and is REQUIRED
dropdownList={array}                    :dropdownList is the items you wish to see when dropdown is clicked( also REQUIRED )
hasSearchBox={true}                     :You can define wether you want to have a search box or not
hasCheckbox={false}                     :Enables you to choose between single-select/multi-select modes
handleSelect={handleSelect}             :HandleSelect must be defined in parent component and will be given "tag" and "value" as function's parameters(REQUIRED)
handleSearch={handleSearch}             :HandleSearch is also defined in parent component and will be given "tag" and "value" as function's parameters
deleteSelectedItems={deleteAll}         :In case you want to delete all the selected values and it must be defined in parent(REQUIRED)
*
 */
